import { SuggestionListItemCategory, SuggestionsList } from './suggestions-list';
import { getCategoryElementIndex } from './utils/get-element-index';
import React from 'react';
import { CategorySuggestion, SlicedSuggestions } from 'types/suggestions';
import { useSuggestionsButtonAction } from '../hooks/use-suggestions-button-action';
import { useTranslation } from 'react-i18next';

export type CategoriesListProps = {
  suggestionSelector: string;
  productsLength: number;
  slicedCategories: CategorySuggestion[];
  suggestions: SlicedSuggestions;
  index: number;
  buttonAction: ReturnType<typeof useSuggestionsButtonAction>;
  isSrp: boolean;
  isDefaultList: boolean;
  showOnlyCategories: boolean;
};

export const CategoriesList: React.FC<CategoriesListProps> = ({
  suggestionSelector,
  productsLength,
  slicedCategories,
  suggestions,
  index,
  isSrp,
  buttonAction,
  isDefaultList,
  showOnlyCategories,
}) => {
  const { t } = useTranslation();

  const showCategoriesDivider: boolean =
    showOnlyCategories || (slicedCategories.length > 0 && productsLength > 0);

  if (showOnlyCategories || !isDefaultList) {
    return (
      <SuggestionsList
        suggestionSelector={suggestionSelector}
        withTitle={false}
        withDivider={showCategoriesDivider}
        title={t('header.searchbar.categories')}
        aria-label={t('header.searchbar.categories-aria')}
        data-qa={'category-suggestions'}
      >
        {slicedCategories.map((item, idx) => (
          <SuggestionListItemCategory
            categorySuggestion={item}
            elementIndex={getCategoryElementIndex(idx, suggestions, isDefaultList)}
            navigationIndex={index}
            buttonAction={buttonAction}
            isSrp={isSrp}
            suggestionSelector={suggestionSelector}
            key={item.serviceId}
          />
        ))}
      </SuggestionsList>
    );
  } else {
    return null;
  }
};
